import {
  GET_QUALIFICATIONS,
  QualificationsActionTypes,
  SET_ASSESSMENT,
  SET_ERROR,
  SET_QUALIFICATIONS,
  SET_QUALIFICATION,
  GET_ASSESSMENT_VERSIONS,
  SET_ASSESSMENT_VERSIONS,
  SET_ASSESSMENT_VERSION,
} from './types';
import { Qualification, QualificationData } from '../../types/Qualifications';
import { Assessment } from '../../types/Syllabuses';

export const getQualifications = (): QualificationsActionTypes => ({
  type: GET_QUALIFICATIONS,
});

export const setQualifications = (qualificationData: QualificationData): QualificationsActionTypes => ({
  type: SET_QUALIFICATIONS,
  payload: { qualificationData },
});

export const setError = (): QualificationsActionTypes => ({
  type: SET_ERROR,
});

export const setQualification = (selectedQualification: Qualification): QualificationsActionTypes => ({
  type: SET_QUALIFICATION,
  payload: { selectedQualification },
});

export const setAssessment = (selectedAssessment: Assessment | undefined): QualificationsActionTypes => ({
  type: SET_ASSESSMENT,
  payload: { selectedAssessment },
});

export const setAssessmentVersion = (
  version: number,
  availableIn: string[] | undefined,
): QualificationsActionTypes => ({
  type: SET_ASSESSMENT_VERSION,
  payload: { version, availableIn },
});

export const getAssessmentVersions = (): QualificationsActionTypes => ({
  type: GET_ASSESSMENT_VERSIONS,
});

export const setAssessmentVersions = (assessmentVersions: Assessment[] | undefined): QualificationsActionTypes => ({
  type: SET_ASSESSMENT_VERSIONS,
  payload: { assessmentVersions },
});

export default {
  getQualifications,
  setQualifications,
  setError,
  setQualification,
  setAssessment,
  getAssessmentVersions,
  setAssessmentVersions,
  setAssessmentVersion,
};
